(function ( $ ) {
    $.fn.ajaxFormSubmit = function(onComplete, onError, onBeforeSubmit) {
        $(this).unbind('submit.ajaxFormSubmit').bind('submit.ajaxFormSubmit', function(e) {
            e.preventDefault();
            if(window.location.toString().split('#test').length == 2) {
                $(this).attr('target','_blank');
                $(this).unbind('submit');
                $(this).submit();
                return;
            }
            var elm = $(this);

            var url = elm.attr('action');
            if(url == "#") {
                $(this).unbind('submit.ajaxFormSubmit');
                return false;
            }
            let type = elm.find('input[name="_method"]').val();
            if (!type) {
                type = elm.attr('method') ? elm.attr('method') : 'GET';
            }
            var dataType = elm.attr('data-datatype') ? elm.attr('data-datatype') : 'html';
            if(onError == undefined) {
                onError = function(xhr, status, error) {
                    console.error(error);
                };
            }
            elm.find('.is-invalid-label').removeClass('is-invalid-label');
            elm.find('.is-invalid-input').removeClass('is-invalid-input');
            elm.find('span.form-error.is-visible').removeClass('is-visible');
            if(onBeforeSubmit != undefined) {
                onBeforeSubmit();
            } else {
                elm.isLoading();
            }

            if(elm.find('.mce-tinymce').length > 0) {
                tinyMCE.triggerSave();
            }

            const ajaxArgs = {
                url: url,
                type: type.toUpperCase(),
                dataType: dataType,
                data: elm.serializeJSON()
            };

            if ($(this).is('[enctype="multipart/form-data"]')) {
                ajaxArgs.async = false;
                ajaxArgs.cache = false;
                ajaxArgs.contentType = false;
                ajaxArgs.dataType = 'application/json';
                ajaxArgs.encType = 'multipart/form-data';
                ajaxArgs.processData = false;
                ajaxArgs.data = new FormData($(this)[0]);
            }

            $.ajax(ajaxArgs).done(function(data) {
                onComplete(data, elm);
            }).fail(function(xhr,status,error) {
                if(xhr.status === 422) {
                    var errors = JSON.parse(xhr.responseText);
                    for(var key in errors) {
                        var error_text = errors[key];
                        var label_key = key.replace(new RegExp('\\.', 'g'), '-');

                        var l = elm.find('label[for='+label_key+']:first');
                        var input = null;
                        if(l.length == 0) {
                            var input_name = make_name_of_key(key);
                            input = elm.find('[name='+input_name+']');
                            if(input.length > 0) {
                                if(input.parents('label:first').length > 0) {
                                    l = input.parents('label:first');
                                } else if(input.parents('.column').length > 0) {
                                    l = input.parents('.column').find('label[for="'+input.attr('id')+'"]:first');
                                }
                            } else {
                                var selector = '[name='+input_name+'\\[\\]]';
                                input = elm.find(selector);
                                if(input.length > 0) {

                                    //Check if the array of inputs is in a table
                                    if(elm.find(selector+':first').parents('table').length > 0) {
                                        var table = elm.find(selector).parents('table');

                                        l = table.parents('label');
                                    }
                                } else {
                                    //Still not found, check if you can remove the first numeric key and find it then
                                    //Example: invoices[0][email] = invoices[][email]
                                    var p = input_name.split('[');
                                    if(p[1] && !isNaN(p[1].split('\\')[0])) {
                                        var i = p[1].split('\\')[0];
                                        p[1] = ''+'\\]\\';
                                        input_name = p.join('[');

                                        elm.find('[name='+input_name+']').each(function(index) {
                                            if(i == index) {
                                                input = $(this);
                                                var id = input.attr('id');
                                                if(id == undefined) {
                                                    id = get_unique_id();
                                                    input.attr('id');
                                                }
                                                l = elm.find('label[for="'+id+'"]');
                                                if(l.length == 0) {
                                                    input.after('<label style="display: none; visibility: hidden;" for="'+id+'"></label>');
                                                    l = elm.find('label[for="'+id+'"]:first');
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        } else {
                            input = elm.find(':input#'+label_key);
                            if(input.length > 0) {
                                input = l.find(':input:first');
                            }
                        }
                        if(l.length > 0 && input.length > 0) {
                            l.addClass('is-invalid-label');
                            input.addClass('is-invalid-input');

                            var span = l.find('span.form-error');
                            if(span.length == 0) {
                                l.append('<span class="form-error"></span>');
                                span = l.find('span.form-error:first');
                            }
                            var label_text = l.attr('data-label');
                            if(label_text == undefined) {
                                var c = l.clone();
                                c.find('*').remove();
                                var text = c.text();


                                label_text = text.toLowerCase().replace(':','').trim();
                                l.attr('data-label', label_text);
                            }


                            error_text = error_text[0].toString().replace(key, label_text).replace((key.split('_').join(' ')), label_text);

                            var custom_error = l.attr('data-custom-error');
                            if(custom_error != undefined) {
                                error_text = custom_error;
                            }

                            span.addClass('is-visible').html(error_text);



                            input.bind('change keydown', function() {
                                $(this).removeClass('is-invalid-input');
                                var l = $(this).parents('label');
                                if(l.length == 0) {
                                    l = $(this).parents('.column').find('label[for="'+$(this).attr('id')+'"]:first');
                                }
                                l.removeClass('is-invalid-label');
                                l.find('span.form-error').remove();
                            });
                        } else {
                            if(key.split('.').length == 1) {
                                //Only flash for non-array errors
                                squde_flash(error_text, 'alert');
                            }
                        }
                    }
                    const reveal = elm.parents('.reveal');
                    if (reveal.find('.scroll-screen-wrapper').length > 0) {
                        const firstFaultyInputScreen = reveal.find('.is-invalid-label').parents('.scroll-screen');

                        const wrapper = reveal.find('.scroll-screen-wrapper');
                        wrapper.find('.active').removeAttr('active');
                        firstFaultyInputScreen.addClass('active');

                        if (firstFaultyInputScreen.index() < 0) {
                            return;
                        }

                        const left = wrapper.width() * firstFaultyInputScreen.index();
                        wrapper.height(firstFaultyInputScreen.outerHeight());

                        wrapper.stop(true,false).animate({'scrollLeft': left}, 500);
                    }
                }

                if (xhr.status === 200 && error === 'No conversion from text to application/json') {
                    const text = xhr.responseText;
                    try {
                        const data = JSON.parse(text);
                        onComplete(data, elm);
                    } catch (e) {
                        onError(xhr, status, error, elm);
                    }
                } else {
                    onError(xhr, status, error, elm);
                }
            }).always(function() {
                elm.doneLoading();
            });
        });

        function make_name_of_key(key) {
            //contact = contact
            //contact.name = contact[name]
            //contact.0.name = contact[0][name]
            var str = "";
            var parts = key.split('.');
            for(var no in parts) {
                //noinspection JSUnfilteredForInLoop
                var add = parts[no];
                if(no > 0) {
                    add = "\\["+add+"\\]";
                }
                str+=add;
            }
            return str;
        }

        return this;
    };

}( jQuery ));
